import React, { useState } from 'react';
import Button from '../ui/Button';
import { downloadPrintChartsJobList } from '../../utils/qaqc/chartImageExport';

/**
 * Runs print-style chart export(s) off-screen (white background) and downloads PNG(s).
 * @param {() => Array<{ Component, props, filenameStem }>} getJobs
 */
const ChartImageDownloadButton = ({
  getJobs,
  label = 'Download chart image (print style)',
  disabled = false
}) => {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    let jobs;
    try {
      jobs = getJobs();
    } catch (e) {
      console.error(e);
      alert(`Could not prepare export: ${e.message}`);
      return;
    }
    if (!jobs?.length) {
      alert('No chart data to export for the current filters.');
      return;
    }

    setBusy(true);
    try {
      await downloadPrintChartsJobList(jobs);
    } catch (e) {
      console.error(e);
      alert(`Export failed: ${e.message || 'Unknown error'}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button type="button" variant="secondary" onClick={handleClick} disabled={disabled || busy}>
      {busy ? 'Rendering…' : label}
    </Button>
  );
};

export default ChartImageDownloadButton;
